// @ts-nocheck
import { call, put } from 'redux-saga/effects';
import { handleMessageText } from './handleMessageText';
import { handleMessageIntent } from './handleMessageIntent';
import { handleMessageChart } from './handleMessageChart';
import { handleError } from '../../../handleError';
import { handleMessageError } from './handleMessageError';
import { wsActions } from '../../actions';

export function* handleResponseChat(payload) {
  yield put(wsActions.stopWaiting());
  try {
    if (
      payload.action === 'response'
      && payload.event === 'message'
    ) {
      yield call(handleMessageText, payload.data);
    }
    if (
      payload.action === 'response'
      && payload.event === 'chart'
    ) {
      yield call(handleMessageChart, payload.data);
    }
    if (
      payload.action === 'response'
      && payload.event === 'message-intent'
      && payload.data.intent === 'chart'
    ) {
      console.log('payload.data', payload.data);
      yield call(handleMessageIntent, payload.data);
    }
    if (payload.action === 'error') {
      yield call(handleMessageError, payload.data);
    }
  } catch (e) {
    yield handleError(e);
  }
}
